import styled from 'styled-components'

export const StyledNewsLayout = styled.div`
  overflow-y: scroll;
  height: calc(100vh - 195px);
  margin-left: -15px;
  margin-right: -15px;
`
